import React from 'react';
import styles from './css/SourceGroup.styl';
import SourceItem from './SourceItem';
import {gaClickHandler} from '../../../../shared/utilities/GAHelpers';
import _ from 'lodash';
import classNames from 'classnames';
import {
  OBIT_TYPE_LEGACY,
  OBIT_TYPE_TRIBUTES_UNPAID,
} from '../../../../shared/utilities/constants';

/**
 * Remove  tributes unpaid because at this point we have other obits
 * @param  {Array} obits List of obituaries to be rendered
 * @return {Array} A filtered list of obituaries
 */
export function filterObits(obits) {
  return _.filter(
    obits,
    obit =>
      obit.obituaryType !== OBIT_TYPE_TRIBUTES_UNPAID &&
      obit.obituaryType !== OBIT_TYPE_LEGACY &&
      _.get(obit, 'affiliate.active') === 'Active'
  );
}

/**
 * The services section of the services group on the person page
 * @param   {Object}  props - passed down props
 * @return  {JSX}     Returns the services group
 */
const SourceGroup = props => {
  const {
    isLegacySourced,
    isSingleTributesUnpaid,
    position,
    renderedObits,
    sourceHeaderText,
  } = props;

  const filteredObits = filterObits(renderedObits);

  return (!isLegacySourced && _.size(filteredObits) !== 0) ||
    isSingleTributesUnpaid ? (
    <aside className={classNames(styles.SourceGroup, styles[position])}>
      <section>
        {isSingleTributesUnpaid ? (
          <a
            className={styles.readFullLink}
            data-ga-no-auto-tag="true"
            href={_.get(renderedObits, '[0].href')}
            onClick={gaClickHandler(
              'bypage_person',
              'readmore_fullobitsigngblink_click',
              _.head(renderedObits)
            )}
          >
            <h2>{sourceHeaderText} &rsaquo;</h2>
          </a>
        ) : (
          <div className={styles.sourceWrapper}>
            <h2>{sourceHeaderText}</h2>
            <div>
              {filteredObits.map((obit, key) => (
                <div className={styles.sourceItem} key={key}>
                  <SourceItem obit={obit} />
                </div>
              ))}
            </div>
          </div>
        )}
      </section>
    </aside>
  ) : null;
};

SourceGroup.propTypes = {
  isLegacySourced: React.PropTypes.bool,
  isSingleTributesUnpaid: React.PropTypes.bool,
  position: React.PropTypes.string,
  renderedObits: React.PropTypes.array,
  sourceHeaderText: React.PropTypes.string,
};

export default SourceGroup;



// WEBPACK FOOTER //
// ./src/reactModules/pages/Person/components/SourceGroup/SourceGroup.js